/* Hydration Bundle v2 — shared behavior for hb2-* sections.
   Ported from Yerba Landing Page Strategy/prototype/js/script.js.
   Several sections include this file as type="module", so the browser runs it
   once per page. Every init still marks what it has bound (data-hb2-ready) and
   is safe to run more than once, since it also re-runs on shopify:section:load
   so the theme editor preview keeps working. */
(function () {
  if (window.__hb2) { window.__hb2.init(document); return; }

  function once(el) {
    if (el.hasAttribute('data-hb2-ready')) return false;
    el.setAttribute('data-hb2-ready', '');
    return true;
  }

  // ============ Accordions ============
  function initAccordions(root) {
    root.querySelectorAll('.hb2 [data-accordion]').forEach(function (accordion) {
      if (!once(accordion)) return;
      var triggers = accordion.querySelectorAll('.accordion__trigger');

      triggers.forEach(function (trigger) {
        var panel = trigger.nextElementSibling;
        panel.style.maxHeight = trigger.getAttribute('aria-expanded') === 'true'
          ? panel.scrollHeight + 'px'
          : '0px';

        trigger.addEventListener('click', function () {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';

          triggers.forEach(function (otherTrigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
            otherTrigger.nextElementSibling.style.maxHeight = '0px';
          });

          if (!isOpen) {
            trigger.setAttribute('aria-expanded', 'true');
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      });
    });
  }

  // ============ Touch/drag-to-scroll for horizontal scrollers ============
  function enableDragScroll(el) {
    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScrollLeft = 0;

    el.addEventListener('pointerdown', function (e) {
      dragging = true;
      moved = false;
      startX = e.clientX;
      startScrollLeft = el.scrollLeft;
      el.classList.add('is-dragging');
      el.setPointerCapture(e.pointerId);
    });

    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = startScrollLeft - dx;
    });

    function endDrag() {
      dragging = false;
      el.classList.remove('is-dragging');
    }
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('pointerleave', endDrag);

    // Don't let a drag also register as a click on a card underneath it.
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function initScrollers(root) {
    root.querySelectorAll('.hb2 .ingredient-scroller').forEach(function (el) {
      if (once(el)) enableDragScroll(el);
    });
  }

  // ============ Supplement Facts collapse (mobile) ============
  function initSfp(root) {
    root.querySelectorAll('.hb2 [data-sfp-collapse]').forEach(function (collapse) {
      if (!once(collapse)) return;
      var btn = collapse.querySelector('.sfp-collapse__btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        collapse.classList.add('is-expanded');
      });
    });
  }

  // ============ Influencer video tiles (autoplay muted in view, tap for sound) ============
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function initVideoTiles(root) {
    root.querySelectorAll('.hb2 .video-tile').forEach(function (tile) {
      var vid = tile.querySelector('video');
      if (!vid || !once(tile)) return;
      vid.muted = true; vid.loop = true; vid.playsInline = true;

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              if (vid.preload === 'none') vid.preload = 'metadata';
              play(vid);
              tile.classList.add('playing');
            } else {
              vid.pause();
            }
          });
        }, { threshold: 0.4 }).observe(vid);
      }

      tile.addEventListener('click', function () {
        if (vid.muted) {
          document.querySelectorAll('.hb2 .video-tile video').forEach(function (o) { if (o !== vid) o.muted = true; });
          vid.muted = false;
          play(vid);
          tile.classList.add('playing');
        } else {
          vid.muted = true;
        }
      });
    });
  }

  function init(root) {
    initAccordions(root);
    initScrollers(root);
    initSfp(root);
    initVideoTiles(root);
  }

  window.__hb2 = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
